export { default } from './src/error-boundary';